import React from 'react'
import styles from './Footer.module.css'
import { useLang } from '../../i18n/LanguageContext'

const PRODUCTS = [
  { label: 'SIGEC HOC',  href: '#solucoes' },
  { label: 'SIGEC WEB',  href: '#solucoes' },
  { label: 'SIGEC ELOS', href: 'https://elos.eqpitech.com.br' },
  { label: 'BC Report',  href: '#solucoes' },
  { label: 'MOBI',       href: '#solucoes' },
  { label: 'COA',        href: '#solucoes' },
]

const NAV_HREFS = ['#sobre', '#historia', '#solucoes', '#clientes', '#contato']

export default function Footer() {
  const { T } = useLang()
  const year = new Date().getFullYear()
  const f = T.footer

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.top}>
          {/* Brand */}
          <div className={styles.brand}>
            <img src="/logos/Logo_EQPI.svg" alt="EQPI Tech" className={styles.logoImg} />
            <p className={styles.tagline}>{f.tagline}</p>
            <a href="https://www.instagram.com/eqpi.tech" target="_blank" rel="noopener noreferrer" className={styles.social}>
              Instagram @eqpi.tech
            </a>
            <a href="https://www.linkedin.com/company/eqpi-tech-software-solu%C3%A7%C3%B5es-corporativas" target="_blank" rel="noopener noreferrer" className={styles.social}>
              LinkedIn
            </a>

            {/* Offices */}
            <div className={styles.offices}>
              {f.offices.map((o) => (
                <div key={o.city} className={styles.officeItem}>
                  <span className={styles.officeCity}>{o.city}</span>
                  <span className={styles.officeAddr}>
                    {o.address.split('\n').map((line, i, arr) => (
                      <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Col 2: Products */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>{f.solutions}</h4>
            <ul className={styles.navList}>
              {PRODUCTS.map((p) => (
                <li key={p.label}>
                  <a href={p.href} className={styles.navLink} target={p.href.startsWith('http') ? '_blank' : undefined} rel={p.href.startsWith('http') ? 'noopener noreferrer' : undefined}>
                    {p.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Navigation */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>{f.company}</h4>
            <ul className={styles.navList}>
              {f.nav.map((label, i) => (
                <li key={i}>
                  <a href={NAV_HREFS[i]} className={styles.navLink}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>{f.contact}</h4>
            <div className={styles.contactList}>
              <a href="tel:+5511988049376" className={styles.contactItem}>(11) 98804-9376</a>
              <a href="mailto:comercial@eqpitech.com.br" className={styles.contactItem}>comercial@eqpitech.com.br</a>
              <a href="tel:+351227313256" className={styles.contactItem}>+351 227 313 256</a>
            </div>
            <h4 className={`${styles.colTitle} ${styles.colTitleSm}`}>{f.support}</h4>
            <div className={styles.contactList}>
              <a href="https://wa.me/551150396769" target="_blank" rel="noopener noreferrer" className={styles.contactItem}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{flexShrink:0,marginTop:'1px'}}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                (11) 5039-6769
              </a>
              <a href="tel:+551123053881" className={`${styles.contactItem} ${styles.contactVoice}`}>
                +55 11 2305-3881 <span className={styles.voiceTag}>{f.supportVoice}</span>
              </a>
              <a href="mailto:suporte@equipoinfo.com.br" className={styles.contactItem}>suporte@equipoinfo.com.br</a>
            </div>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>© {year} EQPI Tech. {f.copyright}</span>
          <span>Equipo Info Serviços de TI Ltda — CNPJ 21.270.860/0001-15</span>
        </div>
      </div>
    </footer>
  )
}
